import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import {
  CollegeVisitCompanionId,
  collegeVisitCompanionContent,
} from '@backrs_ui/grow-ui/src/pages/CollegeVisitGuide/content';

export const useAgentContext = (companionId: CollegeVisitCompanionId) => {
  const page = collegeVisitCompanionContent[companionId];

  useRegisterAgentContext({ kind: 'tab', title: page.tabTitle });

  useRegisterAgentContext({
    kind: 'section',
    title: page.title,
    description: page.subtitle,
    detail: [
      ...(page.howToUse ? [page.howToUse] : []),
      ...page.groups.map((group) =>
        [
          group.title,
          ...group.questions.map(
            (item, index) => `${index + 1}. ${item.question}${item.note ? ` (${item.note})` : ''}`,
          ),
        ].join('\n'),
      ),
    ].join('\n\n'),
  });
};
